import { render, staticRenderFns } from "./Storedetail.vue?vue&type=template&id=bdc81dcc&scoped=true&"
import script from "./Storedetail.vue?vue&type=script&lang=js&"
export * from "./Storedetail.vue?vue&type=script&lang=js&"
import style0 from "./Storedetail.vue?vue&type=style&index=0&id=bdc81dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc81dcc",
  null
  
)

export default component.exports